export const stagesMixin = {
  methods: {
    getStageMixin(stageCode) {
      switch (stageCode) {
        case 101:
          return {
            title: 'Not submitted',
            value: 'not_submitted',
            stage: stageCode,
          };
        case 102:
          return {
            title: 'Not contacted',
            value: 'not_contacted',
            stage: stageCode,
          };
        case 103:
          return {
            title: 'Contacted',
            value: 'contacted',
            stage: stageCode,
          };
        case 104:
          return {
            title: 'Interviewing',
            value: 'interviewing',
            stage: stageCode,
          };
        case 106:
          return {
            title: 'Offered employment',
            value: 'offered_employment',
            stage: stageCode,
          };

        case 107:
          return {
            title: 'Employed',
            value: 'employed',
            stage: stageCode,
          };

        case 108:
          return {
            title: 'No longer interested',
            value: 'no_longer_interested',
            stage: stageCode,
          };

        case 109:
          return {
            title: 'Not in consideration',
            value: 'not_in_consideration',
            stage: stageCode,
          };

        case 'not_submitted':
          return {
            title: 'Not submitted',
            value: 'not_submitted',
            stage: 101,
          };

        case 'not_contacted':
          return {
            title: 'Not contacted',
            value: 'not_contacted',
            stage: 102,
          };

        case 'contacted':
          return {
            title: 'Contacted',
            value: 'contacted',
            stage: 103,
          };

        case 'interviewing':
          return {
            title: 'Interviewing',
            value: 'interviewing',
            stage: 104,
          };

        case 'offered_employment':
          return {
            title: 'Offered employment',
            value: 'offered_employment',
            stage: 106,
          };

        case 'employed':
          return {
            title: 'Employed',
            value: 'employed',
            stage: 107,
          };

        case 'no_longer_interested':
          return {
            title: 'No longer interested',
            value: 'no_longer_interested',
            stage: 108,
          };

        case 'not_in_consideration':
          return {
            title: 'Not in consideration',
            value: 'not_in_consideration',
            stage: 109,
          };

        default:
          return {
            title: '',
            value: '',
            stage: stageCode,
          };
      }
    },
    getStageColorClass(stageCode) {
      /*  public const STAGE_NOT_SUBMITTED = 101;
      public const STAGE_NOT_CONTACTED = 102;
      public const STAGE_CONTACTED = 103;
      public const STAGE_INTERVIEWING = 104;
      public const STAGE_OFFERED_EMPLOYMENT = 106;
      public const STAGE_EMPLOYED = 107;
      public const STAGE_NO_LONGER_INTERESTED = 108;
      public const STAGE_NOT_IN_CONSIDERATION = 109; */

      let colorClass;

      switch (Number(stageCode)) {
        case 101:
          colorClass = 'stage-color-not-submitted';
          break;

        case 102:
          colorClass = 'stage-color-not-contacted';
          break;

        case 103:
          colorClass = 'stage-color-contacted';
          break;

        case 104:
          colorClass = 'stage-color-interviewing';
          break;

        case 106:
          colorClass = 'stage-color-offered-employment';
          break;

        case 107:
          colorClass = 'stage-color-employed';
          break;

        case 108:
          colorClass = 'stage-color-no-longer-interested';
          break;

        case 109:
          colorClass = 'stage-color-not-in-consideration';
          break;

        default:
          colorClass = '';
          break;
      }

      return colorClass;
    },
    getStageColorClassByTitle(stageTitle) {
      /*  public const STAGE_NOT_SUBMITTED = 101;
      public const STAGE_NOT_CONTACTED = 102;
      public const STAGE_CONTACTED = 103;
      public const STAGE_INTERVIEWING = 104;
      public const STAGE_OFFERED_EMPLOYMENT = 106;
      public const STAGE_EMPLOYED = 107;
      public const STAGE_NO_LONGER_INTERESTED = 108;
      public const STAGE_NOT_IN_CONSIDERATION = 109; */

      let colorClass;

      switch (stageTitle) {
        case 'Not submitted':
          colorClass = 'stage-color-not-submitted';
          break;

        case 'Not contacted':
          colorClass = 'stage-color-not-contacted';
          break;

        case 'Contacted':
          colorClass = 'stage-color-contacted';
          break;

        case 'Interviewing':
          colorClass = 'stage-color-interviewing';
          break;

        case 'Offered employment':
          colorClass = 'stage-color-offered-employment';
          break;

        case 'Employed':
          colorClass = 'stage-color-employed';
          break;

        case 'No longer interested':
          colorClass = 'stage-color-no-longer-interested';
          break;

        case 'Not in consideration':
          colorClass = 'stage-color-not-in-consideration';
          break;

        default:
          colorClass = '';
          break;
      }

      return colorClass;
    },
  },
};
